import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { alrajhiValetURL, baseUrl, customHeaders, ksaProjectsBaseURL, thriweMarketPlaceUrl, uaeProjectsBaseURL } from '../../../../Containers/Config/index.js';
import { VENDOR_DOWNLOAD_LIST, VENDOR_DOWNLOAD_LIST_SUCCESS, VENDOR_DOWNLOAD_LIST_ERROR } from './../../actionType.js';
import apiCall from '../../apiCall';
import { Constant } from '../../../../Containers/Helpers/constant.js';

function* getVendorDownloadsList({ payload }) {
  const userData = JSON.parse(localStorage.getItem('authUser'));
  const selectedClientCode = localStorage.getItem('SELECTED_CLIENT_CODE');
  try {
    const baseURL =
  selectedClientCode == 'ALRAJHI_GOLF'
    ? alrajhiValetURL
    : Constant.PROJECT_CODE === 'SAB'
    ? ksaProjectsBaseURL
    : uaeProjectsBaseURL;
    const response = yield call(apiCall, {
      url: `${baseURL}/vendor/downloadsInfo`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...(Constant.PROJECT_CODE === 'SAB' ? { 'Project-Code': payload?.headers?.['Project-Code'] } : customHeaders),
      },
      params: {
        ...payload?.urlParam,
        pageSize: Constant?.TABLE_PAGE_SIZE,
      },
    });

    if (response.status === 200) {
      yield put({
        type: VENDOR_DOWNLOAD_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: VENDOR_DOWNLOAD_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: VENDOR_DOWNLOAD_LIST_ERROR, payload: error });
  }
}

export function* watchVendorDownloadsList() {
  yield takeEvery(VENDOR_DOWNLOAD_LIST, getVendorDownloadsList);
}

function* vendorDownloadsListSaga() {
  yield all([fork(watchVendorDownloadsList)]);
}

export default vendorDownloadsListSaga;
